<template>
  <div class="allergens">
    <section class="allergen-list">
      <p v-for="allergen in currentAllergens" :key="allergen">{{ allergen.name }}&emsp;</p>
    </section>
    <details>
      <summary>Add allergen</summary>
      <section class="grid">
        <div v-for="(allergen, idx) in existingAllergens" :key="idx" class="container">
          <label for="allergen">{{ allergen.name }}</label>
          <ToggleSwitch :modelName="allergen.name" :modelValue="allergen.contains" @update:modelValue="emitAllergen(allergen.name, $event)" />
        </div>
        <div v-if="unlisted" class="container unlisted">
          <label for="custom">Other</label>
          <span class="interaction">
            <input name="custom" type="text" v-model="other" />
            <font-awesome-icon icon="fa-plus" class="icon" size="xl" @click.stop.prevent="emitAllergen(other, true, true)" />
          </span>
        </div>
      </section>
    </details>
  </div>
</template>

<script>
import ToggleSwitch from "./ToggleSwitch.vue";
import { mapGetters } from "vuex";

export default {
  name: "AllergenList",
  components: {
    ToggleSwitch,
  },
  props: {
    allergens: {
      type: Array,
      required: false,
    },
    unlisted: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ["allergenChanged"],
  data() {
    return {
      other: "",
    };
  },
  methods: {
    emitAllergen(allergen, contains, custom = false) {
      if (custom) {
        this.existingAllergens.push({ name: allergen, contains: true });
      } else {
        this.existingAllergens.forEach((all) => {
          if (all.name === allergen) {
            all.contains = contains;
          }
        });
      }
      this.$store.dispatch("updateCustomerAllergens", this.existingAllergens);
      this.other = "";
    },
  },
  computed: {
    currentAllergens() {
      let removedAllergen = this.existingAllergens.filter((allergen) => allergen.contains);
      return removedAllergen;
    },

    existingAllergens() {
      if (this.allergens) {
        return this.allergens;
      } else {
        return this.getCustomerAllergenList;
      }
    },
    ...mapGetters({
      getCustomerAllergenList: "getCustomerAllergenList",
    }),
  },
  mounted() {
    // Lifecycle hook when the component is mounted
  },
};
</script>

<style scoped>
.allergen-list {
  display: flex;
  flex-direction: column;
}

.allergen-list {
  display: flex;
  flex-direction: row;
}

summary {
  margin: 0.5rem 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-template-rows: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.5rem;
  background-color: var(--primary-colour);
  border-radius: 10px;
  padding: 0.25rem;
  margin: 0.5rem;
}

.unlisted {
    width: fit-content;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0.5rem;
  background-color: var(--secondary-colour);
  border-radius: 10px;
  padding: 0.5rem;
  .interaction {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    input {
      margin: 0.5rem;
      padding: 0.25rem;
    }
    .icon {
      cursor: pointer;
      color: var(--action-colour);
    }
  }
}

@media only screen and (orientation: portrait) {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    grid-auto-flow: row;
    padding: 1rem;
    justify-items: center;
  }

  .unlisted {
    grid-column: span 2;
    width: 100%;
    padding: 0.25rem 1rem;
  }

  .container {
    width: 90%;
  }
}
</style>
